<template>
  <v-container fluid grid-list-lg>
    <Create
      :CustomerId="CustomerId"
      :createDialog="createDialog"
      @close="createDialog = false"
      @submit="getList()"
    />
    <v-card :loading="loading" outlined>
      <ListTitle
        :access="checkRightStatus(31) && CustomerId"
        :color="$style.purchase.titlebar"
        title="Payment"
        @add="add"
      />

      <div v-if="$vuetify.breakpoint.mdAndUp">
        <v-toolbar dense elevation="0">
          <v-text-field
            rounded
            v-model="search"
            outlined
            prepend-inner-icon="search"
            autofocus
            dense
            label="Search"
            single-line
            hide-details
            clearable
          />
          <v-spacer></v-spacer>
          <DateTimePicker
            defaultRange="since60DaysAgo"
            :range="true"
            v-model="dateTime"
            @submit="getList()"
          />
        </v-toolbar>
        <v-divider></v-divider>
      </div>

      <v-card-text class="mb-0 pb-0" v-else>
        <v-row>
          <v-col cols="12" md="3" sm="12">
            <v-text-field
              v-model="search"
              outlined
              prepend-inner-icon="search"
              rounded
              dense
              label="Search"
              single-line
              hide-details
              clearable
            />
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="12" md="4" sm="12" v-if="!showAll">
            <DateTimePicker
              defaultRange="since60DaysAgo"
              :range="true"
              v-model="dateTime"
              @submit="getList()"
            />
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="payments"
          :loading="loading"
          @current-items="updateTotal"
          :options.sync="options"
          :server-items-length="totalItems"
          :single-expand="singleExpand"
          :expanded.sync="expanded"
          show-expand
          :footer-props="{ 'items-per-page-options': [10, 15, 25, 50, 100] }"
        >
          <template v-slot:item="{ item, isExpanded, expand }">
            <tr class="pointer">
              <td class="text-left">
                <v-btn @click="expand(!isExpanded)" icon>
                  <v-icon>{{
                    isExpanded ? "mdi-chevron-up" : "mdi-chevron-down"
                  }}</v-icon>
                </v-btn>
              </td>
              <td class="text-left" @click="viewpayment(item)">
                {{ item.date | moment("MM/DD/YYYY hh:mm A") }}
              </td>
              <td class="text-left" @click="viewpayment(item)">
                <div>{{ item.localId }}</div>
                <div v-if="item.User" class="font-italic">
                  {{ item.User.name }}
                </div>
              </td>
              <td
                v-if="!CustomerId"
                class="text-left"
                @click="viewProfile(item)"
              >
                {{ item.Customer.name }}
              </td>
              <td class="text-left" @click="viewpayment(item)">
                {{ item.note }}
              </td>
              <td class="text-right" @click="viewpayment(item)">
                {{ item.total | currency }}
              </td>
              <td class="justify-end align-center text-right">
                <v-menu bottom left offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon>
                      <v-icon>more_vert</v-icon>
                    </v-btn>
                  </template>
                  <v-list class="menu-button">
                    <v-list-item v-if="!CustomerId" @click="viewProfile(item)">
                      <v-list-item-title>Profile</v-list-item-title>
                    </v-list-item>
                    <v-divider v-if="!CustomerId"></v-divider>
                    <v-list-item @click="viewpayment(item)">
                      <v-list-item-title>View payment</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>

          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" class="pa-0">
              <v-card color="#F3F8FC" text class="elevation-0">
                <v-card-text class="title">
                  <PaymentDetail
                    :PaymentId="item.id"
                    :CustomerId="CustomerId"
                  />
                </v-card-text>
              </v-card>
            </td>
          </template>

          <v-alert slot="no-results" :value="true" color="error" icon="warning">
            Your search for "{{ search }}" found no results.
          </v-alert>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import paymentService from "../service";
const DateTimePicker = () => import("@/components/DateTimePicker");
import PaymentDetail from "./PaymentDetailList";
import { mapGetters } from "vuex";
const Create = () => import("./Create");
import _ from "lodash";

export default {
  props: {
    CustomerId: { default: null },
    showAll: { default: false },
    due: { default: false },
  },
  name: "payment-list",
  data() {
    return {
      fullTotal: 0,
      total: 0,
      expanded: [],
      singleExpand: true,
      dateTime: {
        start: this.$moment()
          .startOf("days")
          .subtract(60, "days")
          .toISOString(),
        end: this.$moment().endOf("day").toISOString(),
      },
      createDialog: false,
      headers: [],
      payments: [],
      search: "",
      loading: true,
      totalItems: 0,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ["date"],
        sortDesc: [true],
      },
    };
  },
  created() {
    this.loadHeader();
    this.getList();
    this.$events.listen("paymentListEvent", () => this.getList());
  },
  beforeDestroy() {
    this.$events.remove("paymentListEvent");
  },
  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
  },
  components: {
    DateTimePicker,
    Create,
    PaymentDetail,
  },
  watch: {
    options: {
      handler() {
        this.getList();
      },
      deep: true,
    },
    search: _.debounce(function () {
      this.getList();
    }, 400),
  },
  methods: {
    updateTotal(val) {
      this.total = val.reduce((sum, row) => sum + row.total, 0);
    },
    add() {
      this.createDialog = !this.createDialog;
    },
    viewProfile(val) {
      this.$router.push({ path: `/customer/${val.CustomerId}/profile` });
    },
    viewpayment(payment) {
      const routeData = this.$router.resolve({
        path: `/global/payment/${payment.id}/view`,
      });
      window.open(routeData.href, "newwindow", "width=850, height=1100");
    },
    loadHeader() {
      this.headers = [
        {
          text: this.$t("labels.date"),
          align: "left",
          value: "date",
          sortable: true,
        },
        {
          text: "Payment Number",
          align: "left",
          value: "localId",
          sortable: true,
        },
      ];
      if (!this.CustomerId) {
        this.headers.push({
          text: "Customer Name",
          value: "Customer.name",
          align: "left",
          sortable: true,
        });
      }
      this.headers.push(
        { text: "Note", align: "left", value: "note", sortable: true },
        { text: "Total", value: "total", align: "right", sortable: true },
        { text: "", value: "action", sortable: false }
      );
    },
    getList() {
      this.loading = true;
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      const offset = (page - 1) * itemsPerPage;

      const where = {
        start: this.dateTime.start,
        end: this.dateTime.end,
        limit: itemsPerPage,
        offset,
        sortBy: sortBy[0],
        sortDesc: sortDesc[0],
      };
      if (this.CustomerId) where.CustomerId = this.CustomerId;
      if (this.search) where.search = this.search;

      return paymentService.getAll(where).then((response) => {
        this.loading = false;
        // console.log('response', response)
        this.totalItems = response.count;
        this.payments = response.data.map((payment) => {
          payment.total = (payment.PaymentDetails || []).reduce(
            (sum, d) => sum + d.amount,
            0
          );
          return payment;
        });
        this.fullTotal = this.payments.reduce((sum, row) => sum + row.total, 0);
      });
    },
  },
};
</script>